module.exports = __webpack_public_path__ + "img/Pag4.adab7d94.png";